// extracted by mini-css-extract-plugin
export default {"info_container":"styles_info_container__lobQ5","loader_wrapper":"styles_loader_wrapper__gAuxn"};